export const getDisclaimerTitleDetails = (i18n, disclaimer) => {
  const {
    selectedDisclaimer,
  } = disclaimer || {};

  if (selectedDisclaimer && selectedDisclaimer.Name) {
    return selectedDisclaimer.Name;
  }
  return i18n.getString(_TL_('No disclaimer selected'));
};
